import React from "react";
import { translate } from "../Services/translation";
import WarningLoanIcon from '../../icons/warning-loan.svg'

const LoanWarning = () => {

    const link = translate('loan.warning.link');
    const linkTitle = translate('loan.warning.linktitle');
    return (
        <div className="warning-loan__wrapper">
            <div className="warning-loan__div">
                <WarningLoanIcon className="warning-loan__icon" />
            </div>
            <div>
                <p><strong>{translate('loan.warning.title')}</strong><br />
                    {translate('loan.warning.text')}&nbsp;
                    <a href={link} target="_blank" title={linkTitle}>{translate('loan.warning.linktext')}</a>.
                </p>
            </div>
        </div>
    );

};

export default LoanWarning;
